.container {
    text-align: left;
}

.title {
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
}

.mileage {
    color: var(--color-mid-gray);
}

.availableOptions {
    align-items: center;
    color: var(--color-cardinal);
    display: flex;
    gap: 6px;

    & svg {
        height: 24px;
        width: 24px;
    }
}
